import { create } from "zustand";
import { CommonResponseModel, whatsAppPaymentConfiguration } from "../models/axiosModel";
import agent from "../services/api";

interface paymentConfigurationStoreInterface {
    paymentConfigurationData: whatsAppPaymentConfiguration[] | null,
    setPaymentConfigurationData: (value: whatsAppPaymentConfiguration[] | null) => void,

    getPaymentConfigurationApi: (wabaId: string) => Promise<CommonResponseModel<whatsAppPaymentConfiguration>>,

    syncMetaPaymentConfigApi: (meta_integration_whatsapp_id: string) => Promise<any>
}

export const usePaymentConfigurationStore = create<paymentConfigurationStoreInterface>((set) => ({
    paymentConfigurationData: null,
    setPaymentConfigurationData: (value: whatsAppPaymentConfiguration[] | null) => set({ paymentConfigurationData: value }),

    getPaymentConfigurationApi: async (wabaId: string) => {
        const res = await agent.getPaymentConfigurations.get(wabaId);
        if(res?.status){
            set({ paymentConfigurationData: res?.data });
        } else {
            set({ paymentConfigurationData: null });
        }
        return res;
    },

    syncMetaPaymentConfigApi: async (meta_integration_whatsapp_id: string) => {
        const res = await agent.syncMetaPaymentConfig.get(meta_integration_whatsapp_id);
        return res;
    }
}))